import {
  LOGGED_IN,
  LOGGED_OUT,
  RESET_MEMBER
} from './types';

export const login = (value) => {
  return {
    type: LOGGED_IN,
    payload: value
  };
};
export const resetMember = (value) => {
  return {
    type: RESET_MEMBER,
    payload: value
  };
};

export const logout = () => {
  return {
    type: LOGGED_OUT
  };
};
